// packRef 自定义节点(D10:只存 uuid,绝不存 url / thumb 地址)。
//
// content 里的资源包嵌入节点只携带 `packId`(uuid)。详情渲染层收集全部 packId →
// `v_resource_pack_public_meta .in('id', ids)` 运行时解析为卡片 + 链到 /pack/:packId。
// 编辑器内只渲染占位卡(NodeView)。
//
// parseHTML / renderHTML 走 data-pack-id 属性,序列化往返只保留 uuid。

import { Node, mergeAttributes } from '@tiptap/core'

export type PackRefAttrs = {
  packId: string | null
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    packRef: {
      /** 在当前位置批量插入 packRef 节点(只存 packId uuid)。 */
      insertPackRefs: (packIds: string[]) => ReturnType
    }
  }
}

export const PackRefNode = Node.create({
  name: 'packRef',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      packId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-pack-id'),
        renderHTML: (attributes) => {
          const attrs = attributes as PackRefAttrs
          if (!attrs.packId) return {}
          return { 'data-pack-id': attrs.packId }
        },
      },
    }
  },

  parseHTML() {
    return [{ tag: 'div[data-pack-ref]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-pack-ref': '' }, HTMLAttributes)]
  },

  addCommands() {
    return {
      // 必须单次 insertContent 批量插入:atom+selectable 节点插入后选区变成该节点的
      // NodeSelection,循环逐个插入会把上一个节点替换掉,多选只剩最后一个。
      insertPackRefs:
        (packIds: string[]) =>
        ({ commands }) => {
          if (packIds.length === 0) return true
          // 末尾追加空段落:atom 节点收尾时选区会停在其 NodeSelection 上,后续
          // 任何插入/输入都会替换它;以段落收尾则光标落在段落内(文本选区),
          // 且下次向空段落插入时 tiptap 会整体替换该空段落,不会累积空行。
          return commands.insertContent([
            ...packIds.map((packId) => ({ type: this.name, attrs: { packId } })),
            { type: 'paragraph' },
          ])
        },
    }
  },
})
